export const TIMEOUT = 250;

export const PER_PAGE = 24;
